import { Box, Button } from '@mui/material';
import React, { createContext, useState } from 'react';
import CoordinateDetails from './CoordinateDetails';
import AddressDetails from './AddressDetails';
import { FormProvider, useForm } from 'react-hook-form';
import Swal from 'sweetalert2';
import { CustomerService } from '../../Service';

const AddAddress = ({customer,fetchAllAddress}) => {
    const formMethod = useForm({ 
        mode: "onChange",
        defaultValues:{
          customerId:customer.id,
          fullName:`${customer.profile.firstName || ''} ${customer.profile.middleName || ''} ${customer.profile.lastName || ''}`.replace(/\s+/g, ' ').trim(),
          mobileNumber:customer?.mobileNumber,
          address:'',
          addressType:'3',
          apartmentRoadArea:'',
          houseFlatBlockNo:'',
          landmark:'',
          city:'',
          latitude:'',
          longitude:'',
          pincode:'',
          state:'',
          tagName:'',
        }
      });
    const {control, handleSubmit, setValue, formState: { errors ,isDirty},watch,reset} = formMethod;
    const onSubmit = async(data) => {
        console.log(data);
        try{
            Swal.fire({
                title: 'Please Wait...',
                showConfirmButton: false, 
                allowOutsideClick: false,
                allowEscapeKey: false,
                willOpen: () => {
                    Swal.showLoading()
                },
            });
            const createResponse = await CustomerService.addCustomeraddress(data);
            if(createResponse.success == '1'){
                reset();
                fetchAllAddress()
                Swal.fire({
                    title: 'Address added successfully',
                    icon: 'success',
                    showCancelButton: false,
                    timer:1000
                });
                
                
            }else if (createResponse.success == '0'){
                Swal.fire('Failed to add address', '', 'error');
            }

        }catch(error){
            console.log(error);
            Swal.fire('Something went wrong ......', '', 'error');
        }
    }
    
    
  return (
    <FormProvider {...formMethod}>
        <Box component={'form'} onSubmit={handleSubmit(onSubmit)}>
            <CoordinateDetails customer={customer}/>
            <AddressDetails customer={customer} />
            <Box sx={{ display: 'flex', justifyContent: 'center', my: 2 }}>
                <Button size='small' type="submit" variant="contained" color="primary" disabled={!isDirty}>Save</Button>
            </Box>
        </Box>
    </FormProvider>
  );
}

export default AddAddress;
